import { render, staticRenderFns } from "./igt-display-field.vue?vue&type=template&id=15aabec4&scoped=true&"
import script from "./igt-display-field.vue?vue&type=script&lang=js&"
export * from "./igt-display-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aabec4",
  null
  
)

export default component.exports